import { useLingui } from "@lingui/react/macro";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelAudioForm } from "~/components/views/app/channel/audio-form";
import { getChannelAudioTypeOptions } from "~/models/channel-audio";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute("/_app/podcasts/$channelUid/settings/audio")({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.channel.findAudio.queryOptions({
				channelUid: params.channelUid,
			}),
		);
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const { i18n } = useLingui();

	const channelQuery = useSuspenseQuery(trpc.channel.find.queryOptions({ channelUid }));
	const channelAudioQuery = useSuspenseQuery(trpc.channel.findAudio.queryOptions({ channelUid }));

	return (
		<div className="flex w-full flex-col gap-6 px-4">
			<ChannelAudioForm
				channel={channelQuery.data}
				channelAudio={channelAudioQuery.data}
				channelAudioTypes={getChannelAudioTypeOptions(i18n)}
			/>
		</div>
	);
}
